import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Tag,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  BulbOutlined,
  SnippetsOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import InputMask from "../../components/inputMask";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
const { Text } = Typography;

// STATUS
const options_status = {
  [-1]: <Tag color="orange">Em formação</Tag>,
  [0]: <Tag color="green">Aguard. Avaliação.</Tag>,
  [1]: <Tag color="orange">Ideia aceita (Aguard. Informações)</Tag>,
  [2]: <Tag>Ideia c/ oportunidade</Tag>,
  [3]: <Tag color="green">Retorno de info.</Tag>,
  [4]: <Tag color="green">Em desenvolvimento</Tag>,
  [5]: <Tag>Finalizado</Tag>,
};

// STATUS
const options_status_filter = [
  { value: 999, label: "Todos" },
  { value: -1, label: "Em formação" },
  { value: 0, label: "Aguard. Avaliação" },
  { value: 1, label: "Ideia aceita (Aguard. Informações)" },
  { value: 2, label: "Ideia c/ oportunidade" },
  { value: 3, label: "Retorno de info." },
  { value: 4, label: "Em desenvolvimento" },
  { value: 5, label: "Finalizado" },
];

export const Sugestoes = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // OPTIONS
  const [colaboradores, setColaboradores] = useState([]);
  const [areas, setAreas] = useState([]);
  const [classificacoes, setClassificacoes] = useState([]);
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(999);

  useEffect(() => {
    listarAreas();
    listarColaboradores();
    listarClassificacao();
    listarSugestoes();
  }, []);

  // LISTAR COLABORADORES
  const listarColaboradores = async () => {
    setLoading(true);
    const api = await http("get", `v1/usuario/lista_colaboradores`, []);
    if (api.statusCode === 200) {
      let array_colaboradores = [];
      if (api.response.data) {
        api.response.data.map((col) => {
          array_colaboradores.push({
            value: col.id,
            label: `${col.matricula} - ${col.nome}`,
          });
        });
      }
      setColaboradores(array_colaboradores);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR ÁREAS
  const listarAreas = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes_areas/listar_ativas`, []);
    if (api.statusCode === 200) {
      let array_areas = [];
      if (api.response.data) {
        api.response.data.map((col) => {
          array_areas.push({ value: col.id, label: col.descricao });
        });
      }
      setAreas(array_areas);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR CLASSIFICAÇÃO
  const listarClassificacao = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes_classificacao/listar_ativas`, []);
    if (api.statusCode === 200) {
      let array_classificacoes = [];
      if (api.response.data) {
        api.response.data.map((col) => {
          array_classificacoes.push({ value: col.id, label: col.descricao });
        });
      }
      setClassificacoes(array_classificacoes);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarSugestoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarSugestao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarSugestoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarSugestao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarSugestoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarSugestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/sugestoes/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        id_colaborador_solicitante: api.response.data.id_colaborador_solicitante,
        id_sugestoes_cad_classificacao: api.response.data.id_sugestoes_cad_classificacao,
        id_sugestoes_cad_areas: api.response.data.id_sugestoes_cad_areas,
        email: api.response.data.email,
        telefone: api.response.data.telefone,
        titulo: api.response.data.titulo,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarSugestao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarSugestoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Colaborador",
      dataIndex: "colaborador",
      sorter: (a, b) => a.colaborador?.localeCompare(b.colaborador),
    },
    {
      title: "Título",
      dataIndex: "titulo",
      sorter: (a, b) => a.titulo?.localeCompare(b.titulo),
    },
    {
      title: "Área",
      dataIndex: "area",
      sorter: (a, b) => a.area?.localeCompare(b.area),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => options_status[e.status],
      sorter: (a, b) => a.status?.toString()?.localeCompare(b.status?.toString()),
    },
    {
      title: "Ações",
      width: 80,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title={e.status === 1 ? "Responder Solicitação" : "Detalhes sugestão"}>
            <Button
              loading={loading}
              onClick={() => navigate(`/sugestoes/detalhes/${e.id}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
          {(e.status === -1 || e.status === 0) && (
            <React.Fragment>
              <Tooltip title="Preencher sugestão">
                <Button
                  loading={loading}
                  onClick={() => navigate(`/sugestoes/detalhamento-inicial/${e.id}`)}
                  icon={<SnippetsOutlined />}
                />
              </Tooltip>
              <Tooltip title="Editar">
                <Button loading={loading} onClick={() => carregarSugestao(e.id)} icon={<EditOutlined />} />
              </Tooltip>
              <Tooltip title="Excluir">
                <Button
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarSugestao(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
            </React.Fragment>
          )}
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarSugestao(formulario);
    } else {
      cadastrarSugestao(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar, status) => {
    let filteredData = dados?.filter(
      (val) =>
        val.titulo?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.area?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    if (status !== 999) {
      filteredData = filteredData?.filter((e) => e.status === status);
    }
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroStatus) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Sugestão
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="titulo"
                label="Título da Sugestão"
                rules={[{ required: true, message: "Digite o título!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe o título" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_colaborador_solicitante"
                label="Colaborador Responsável"
                rules={[{ required: true, message: "Selecione o colaborador!" }]}>
                <Select
                  showSearch
                  size="large"
                  placeholder="Selecione o colaborador"
                  disabled={loading || idAlt > 0}
                  style={{ width: "100%" }}
                  options={colaboradores}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="telefone"
                label="Celular"
                rules={[
                  { required: true, message: "Digite o celular!" },
                  { min: 5, message: "Username must be minimum 5 characters." },
                ]}>
                <InputMask mask="(99) 9 9999-9999" size="large" disabled={loading} placeholder="Informe o celular" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  { required: true, message: "Digite o e-mail!" },
                  { type: "email", message: "Informe um e-mail válido!" },
                ]}>
                <Input size="large" disabled={loading} placeholder="Informe o e-mail" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_sugestoes_cad_areas"
                label="Área da ideia"
                rules={[{ required: true, message: "Selecione a área!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione a área"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={areas}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_sugestoes_cad_classificacao"
                label="Classificação"
                rules={[{ required: true, message: "Selecione a classificação!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione a classificação"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={classificacoes}
                />
              </Form.Item>
            </Col>

            <Col style={{ marginTop: "10px" }} className="gutter-row" span={24}>
              <Space direction="vertical" size={2}>
                <Text type="secondary" strong>
                  Ideias que PODEM fazer parte:
                </Text>
                <Text type="secondary">
                  <ul>
                    <li>Melhoria da qualidade e produtividade.</li>
                    <li>Redução de custos e despesas.</li>
                    <li>Otimização de processos.</li>
                    <li>Maximização de resultados.</li>
                  </ul>
                </Text>

                <Text type="secondary" strong>
                  Ideias que NÃO PODEM fazer parte:
                </Text>
                <Text type="secondary">
                  <ul>
                    <li>Consertos, reformas e manutenções de máquinas, equipamentos e estrutura.</li>
                    <li>Adequações de atendimento ao Programa 5S.</li>
                    <li>Treinamentos, criação e adequação de cargos / função e benefícios.</li>
                    <li>Ideias previstas no Planejamento Estratégico da Cooperativa.</li>
                    <li>Sugestões que não possuem a descrição de como a inovação possa ser implementada.</li>
                  </ul>
                </Text>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Sugestões"
              subtitle="Gerenciar minhas sugestões"
              icon={<BulbOutlined />}
              loading={loading}
            />
            <Divider />

            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>

                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status_filter}
                />
              </Space>

              <Divider />
              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
